import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import DailyRunRateActions, { dailyRunRateActionTypes } from '@Actions/inventory/dailyRunRateActions';
import DailyRunRateServices from '../../services/inventory/dailyRunRateServices';

function* _createDailyRunRate(action) {
  try {
    yield put(DailyRunRateActions.createDailyRunRateLoading(true));
    const dailyRunRate = yield DailyRunRateServices.createDailyRunRate(action.payload);
    if (dailyRunRate.success) {
      yield put(TrackerActions.trackAction(dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.SUCCESS, dailyRunRate.data));
      notification.open({
        type: 'success',
        message: 'Stock tracking list successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(dailyRunRate?.data?.[0]);
      yield put(DailyRunRateActions.createDailyRunRateLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: dailyRunRate.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DailyRunRateActions.createDailyRunRateLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(DailyRunRateActions.createDailyRunRateLoading(false));
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.ERROR, error));
  }
}

function* createDailyRunRate() {
  yield takeLatest(dailyRunRateActionTypes.CREATE_DAILY_RUN_RATE.REQUEST, _createDailyRunRate);
}

function* _updateDailyRunRate(action) {
  try {
    yield put(DailyRunRateActions.updateDailyRunRateLoading(true));
    const dailyRunRate = yield DailyRunRateServices.updateDailyRunRate(action.payload);
    if (dailyRunRate.success) {
      yield put(TrackerActions.trackAction(dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.SUCCESS, dailyRunRate.data));
      notification.open({
        type: 'success',
        message: 'Stock tracking list successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(dailyRunRate);
      yield put(DailyRunRateActions.updateDailyRunRateLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: dailyRunRate?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DailyRunRateActions.updateDailyRunRateLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(DailyRunRateActions.updateDailyRunRateLoading(false));
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.ERROR, error));
  }
}

function* updateDailyRunRate() {
  yield takeLatest(dailyRunRateActionTypes.UPDATE_DAILY_RUN_RATE.REQUEST, _updateDailyRunRate);
}

function* _getDailyRunRates(action) {
  try {
    DailyRunRateActions.getDailyRunRatesSuccess(null);
    yield put(DailyRunRateActions.getDailyRunRatesLoading(true));
    const {
      payload, callback
    } = action;
    const { tenantId, drrId, page, limit, searchKeyword } = payload;
    const dailyRunRates = yield DailyRunRateServices.getDailyRunRates(tenantId, drrId, page, limit, searchKeyword);
    yield put(DailyRunRateActions.getDailyRunRatesSuccess(dailyRunRates));
    yield put(DailyRunRateActions.getDailyRunRatesLoading(false));
  } catch (error) {
    yield put(DailyRunRateActions.getDailyRunRatesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.GET_DAILY_RUN_RATES.ERROR, error));
  }
}

function* getDailyRunRates() {
  yield takeLatest(dailyRunRateActionTypes.GET_DAILY_RUN_RATES.REQUEST, _getDailyRunRates);
}
function* _getDailyRunRateById(action) {
  try {
    DailyRunRateActions.getDailyRunRateByIdSuccess(null);
    yield put(DailyRunRateActions.getDailyRunRateByIdLoading(true));
    const {
      payload, callback
    } = action;
    const { tenantId, drrId } = payload;
    const selectedDailyRunRate = yield DailyRunRateServices.getDailyRunRates(tenantId, drrId);
    yield put(DailyRunRateActions.getDailyRunRateByIdSuccess(selectedDailyRunRate?.data?.daily_run_rates?.[0]));
    yield put(DailyRunRateActions.getDailyRunRateByIdLoading(false));
  } catch (error) {
    yield put(DailyRunRateActions.getDailyRunRateByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.ERROR, error));
  }
}

function* getDailyRunRateById() {
  yield takeLatest(dailyRunRateActionTypes.GET_DAILY_RUN_RATE_BY_ID.REQUEST, _getDailyRunRateById);
}

function* _deleteDailyRunRate(action) {
  try {
    yield put(DailyRunRateActions.deleteDailyRunRateLoading(true));
    const dailyRunRate = yield DailyRunRateServices.deleteDailyRunRate(action.payload);

    if (dailyRunRate.success) {
      notification.open({
        type: 'success',
        message: 'Stock tracking list successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dailyRunRate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DailyRunRateActions.deleteDailyRunRateLoading(false));
  } catch (error) {
    yield put(DailyRunRateActions.deleteDailyRunRateLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.DELETE_DAILY_RUN_RATE.ERROR, error));
  }
}

function* deleteDailyRunRate() {
  yield takeLatest(dailyRunRateActionTypes.DELETE_DAILY_RUN_RATE.REQUEST, _deleteDailyRunRate);
}

function* _pinDailyRunRate(action) {
  try {
    yield put(DailyRunRateActions.pinDailyRunRateLoading(true));
    const dailyRunRate = yield DailyRunRateServices.pinDailyRunRate(action.payload);

    if (dailyRunRate.success) {
      notification.open({
        type: 'success',
        message: `Stock tracking list successfully ${action?.payload?.is_pinned ? 'pinned on' : 'unpinned from'} inventory dashboard`,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dailyRunRate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DailyRunRateActions.pinDailyRunRateLoading(false));
  } catch (error) {
    yield put(DailyRunRateActions.pinDailyRunRateLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dailyRunRateActionTypes.PIN_DAILY_RUN_RATE.ERROR, error));
  }
}

function* pinDailyRunRate() {
  yield takeLatest(dailyRunRateActionTypes.PIN_DAILY_RUN_RATE.REQUEST, _pinDailyRunRate);
}

export default function* dailyRunRateSaga() {
  yield all([
    createDailyRunRate(),
    getDailyRunRates(),
    getDailyRunRateById(),
    updateDailyRunRate(),
    deleteDailyRunRate(),
    pinDailyRunRate(),
  ]);
}